<mat-card class="example-card" style="margin-bottom: 0px;">
  <mat-card-header class="card-header">
    <mat-card-title *ngIf="!esNuevo">Incidencia #{{item?.Id}}</mat-card-title>
    <mat-card-title *ngIf="esNuevo">Reportar Incidencia</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError?.length > 0">{{msgError}}</mat-label>

    <ng-container *ngIf="!isSearching && item != null">

      <form [formGroup]="formGroup">

        <div fxLayout="row stretch" class="zb-readonly">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Fecha de creación:</b> {{item.FechaCreacion | date:'dd/MM/yyyy HH:mm:ss'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Generado por:</b> {{item.UsuarioCreadorLogin}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%" *ngIf="esNuevo">
              <mat-label *ngIf="!isCategoriaSearching">Categoría*</mat-label>
              <mat-label *ngIf="isCategoriaSearching">Cargando...</mat-label>
              <mat-select formControlName="IncidenciaUsuarioCategoriaId" (selectionChange)="onCategoriaSelect()">
                <mat-option *ngFor="let s of categoriaList" [value]="s.Id">{{s.Nombre}}</mat-option>
              </mat-select>
              <mat-error
                *ngIf="!formGroup.controls['IncidenciaUsuarioCategoriaId'].valid && formGroup.controls['IncidenciaUsuarioCategoriaId'].touched">
                {{ getErrorIncidenciaUsuarioCategoriaId() }}
              </mat-error>
            </mat-form-field>
            <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!esNuevo">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Categoría:</b> {{item.IncidenciaUsuarioCategoriaPadreId > 0 ?
                  item.IncidenciaUsuarioCategoriaPadreNombre : item.IncidenciaUsuarioCategoriaNombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div *ngIf="subCategoriasList?.length > 0 || item.IncidenciaUsuarioCategoriaPadreId > 0" fxFlex=50
            fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!esNuevo">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Subcategoría:</b> {{item.IncidenciaUsuarioCategoriaNombre}}</mat-label>
              </div>
            </mat-expansion-panel>
            <mat-form-field appearance="outline" style="width: 100%" *ngIf="esNuevo && subCategoriasList.length > 0">
              <mat-label *ngIf="!isSubCategoriaSearching">SubCategoria*</mat-label>
              <mat-label *ngIf="isSubCategoriaSearching">Cargando...</mat-label>
              <mat-select [(ngModel)]="incidenciaUsuarioSubCategoriaId" [ngModelOptions]="{standalone: true}">
                <mat-option *ngFor="let s of subCategoriasList" [value]="s.Id">{{s.Nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="esNuevo && canGestionarIncidencia">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Fecha Límite</mat-label>
              <input matInput [matDatepicker]="fechaLimitePicker" formControlName="FechaLimite" readonly
                (click)="fechaLimitePicker.open()">
              <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaLimitePicker">
              </mat-datepicker-toggle>
              <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaLimite')">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #fechaLimitePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="esNuevo && canGestionarIncidencia">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isUsuarioSearching">Usuario Asignado</mat-label>
              <mat-label *ngIf="isUsuarioSearching">Cargando...</mat-label>
              <input matInput type="text" (keyup)="filterUsuarioList($event.target.value)"
                formControlName="UsuarioAsignado" placeholder="Usuario" aria-label="Usuario"
                [matAutocomplete]="usuario">
              <mat-autocomplete [displayWith]="displayUsuario" autoActiveFirstOption
                (optionSelected)="onUsuarioAsignadoChange()" #usuario="matAutocomplete">
                <mat-option *ngFor="let s of filteredUsuarioList" [value]="s">
                  {{s.Login}} - {{s.Nombre}} {{s.Apellido}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="!esNuevo">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Estado:</b> {{item.EstadoNombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!esNuevo">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Código:</b> {{item.Codigo}}</mat-label>
              </div>
            </mat-expansion-panel>
            <mat-form-field appearance="outline" style="width: 100%" *ngIf="esNuevo">
              <mat-label>Código{{codigoRequerido ? '*' : ''}}</mat-label>
              <input matInput formControlName="Codigo" (keyup.enter)="onGuardar()" maxlength="150">
              <mat-error *ngIf="!formGroup.controls['Codigo'].valid && formGroup.controls['Codigo'].touched">
                {{ getErrorCodigo() }}
              </mat-error>
            </mat-form-field>
          </div>

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!esNuevo">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Motivo:</b> {{item.Asunto}}</mat-label>
              </div>
            </mat-expansion-panel>
            <mat-form-field appearance="outline" style="width: 100%" *ngIf="esNuevo">
              <mat-label>Motivo*</mat-label>
              <input matInput formControlName="Asunto" (keyup.enter)="onGuardar()" maxlength="150">
              <mat-error *ngIf="!formGroup.controls['Asunto'].valid && formGroup.controls['Asunto'].touched">
                {{ getErrorAsunto() }}
              </mat-error>
            </mat-form-field>
          </div>

        </div>

        <ng-container *ngIf="categoriaCamposCustomList?.length > 0 && getCampoActivo()">

          <hr style="width: 100%;">

          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">note_add</mat-icon>Datos Adicionales
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <!--CAMPOS CUSTOM-->
            <form [formGroup]="camposCustomGroup" style="width: 100%;" *ngIf="esNuevo">
              <ng-container *ngFor="let item of categoriaCamposCustomList">
                <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item.Activo">
                  <mat-form-field appearance="outline" style="width: 100%;">
                    <mat-label>{{item.NombreCampo}}{{item.Requerido ? '*': ''}}</mat-label>
                    <input matInput formControlName="{{item.NombreCampo}}" (keyup.enter)="onGuardar()" maxlength="300">
                    <mat-error
                      *ngIf="!camposCustomGroup.controls[item.NombreCampo].valid && camposCustomGroup.controls[item.NombreCampo].touched">
                      {{ getErrorCampoCustom(item.NombreCampo) }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </ng-container>
            </form>
            <ng-container *ngFor="let item of item.IncidenciaUsuarioCategoriaCustom">
              <div fxFlex=50 fxFlex.xs=100 class="flex-item zb-readonly" style="margin-right: 10px;" *ngIf="!esNuevo">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>{{getNombreCampo(item)}}:</b> {{getValorCampo(item)}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
            </ng-container>
          </mat-expansion-panel>

        </ng-container>

        <ng-container *ngIf="mostrarTabAsociaciones()">

          <hr style="width: 100%;">

          <mat-expansion-panel [expanded]="false">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">note_add</mat-icon>Asociar Incidencia
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-tab-group>

              <mat-tab label="{{'Persona' | translate}}" *ngIf="canAsociarPersona">

                <form [formGroup]="personaFormGroup" *ngIf="canPersonEdit && esNuevo" style="margin-top: 15px;">

                  <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

                    <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item" width="100%">
                      <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: #add5ff;">
                        <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                          <mat-label>
                            ¿Ya tenes cargados los datos de la persona para asociarlos a este incidente?
                          </mat-label>
                        </div>
                        <br />
                        <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                          <button mat-raised-button (click)="onPersonSearchClick()" [disabled]="isProcessing()"
                            color="accent" class="zb-button">Buscar Datos de Persona Existente</button>
                        </div>
                      </mat-expansion-panel>
                    </div>

                  </div>

                  <hr style="margin:20px 0px; width: 100%;">

                  <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label><b># Persona</b>: {{(persona?.Id > 0 ? persona.Id : 'NUEVO')}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item"
                      style="margin-top: 5px;">
                      <button mat-raised-button (click)="onPersonDeassociateClick()" [disabled]="isProcessing()"
                        *ngIf="canDeassociatePerson()" color="warn" class="zb-button">
                        Cargar como Nueva Persona
                      </button>
                    </div>

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Nombre*</mat-label>
                        <input matInput formControlName="Nombre" maxlength="150" (keyup.enter)="onGuardarUsuario()">
                        <mat-error
                          *ngIf="!personaFormGroup.controls['Nombre'].valid && personaFormGroup.controls['Nombre'].touched">
                          {{ getErrorNombre() }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Apellido*</mat-label>
                        <input matInput formControlName="Apellido" maxlength="150" (keyup.enter)="onGuardarUsuario()">
                        <mat-error
                          *ngIf="!personaFormGroup.controls['Apellido'].valid && personaFormGroup.controls['Apellido'].touched">
                          {{ getErrorApellido() }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label *ngIf="!isTipoDocumentoSearching">Tipo Documento</mat-label>
                        <mat-label *ngIf="isTipoDocumentoSearching">Cargando...</mat-label>
                        <mat-select formControlName="TipoDocumentoId" (selectionChange)="onTipoDocumentoSelection()">
                          <mat-option>Ninguno</mat-option>
                          <mat-option *ngFor="let s of tipoDocumentoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Nro. Documento</mat-label>
                        <input matInput formControlName="NroDocumento" type="text" (change)="onNroDocumentoChange()"
                          maxlength="100" (keyup.enter)="onGuardarUsuario()">
                        <mat-error
                          *ngIf="!personaFormGroup.controls['NroDocumento'].valid && personaFormGroup.controls['NroDocumento'].touched">
                          {{ getErrorNroDocumento() }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="showCuit">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>CUIT/CUIL</mat-label>
                        <input matInput formControlName="Cuit" type="number" (change)="onCuitChange()"
                          (keyup.enter)="onGuardarUsuario()">
                        <mat-error
                          *ngIf="!personaFormGroup.controls['Cuit'].valid && personaFormGroup.controls['Cuit'].touched">
                          {{ getErrorCuit() }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Fecha Nacimiento</mat-label>
                        <input matInput [matDatepicker]="fechaNacimientoPicker" formControlName="FechaNacimiento"
                           (click)="fechaNacimientoPicker.open()">
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaNacimientoPicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix
                          (click)="clearDate('FechaNacimiento')">
                          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #fechaNacimientoPicker></mat-datepicker>
                      </mat-form-field>
                    </div>

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Mail de Contacto</mat-label>
                        <input matInput formControlName="MailContacto" (keyup.enter)="onGuardarUsuario()"
                          maxlength="255">
                        <mat-error
                          *ngIf="!personaFormGroup.controls['MailContacto'].valid && personaFormGroup.controls['MailContacto'].touched">
                          {{ getErrorMailContacto() }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Móvil de Contacto</mat-label>
                        <input matInput formControlName="MovilContacto" (keyup.enter)="onGuardarUsuario()"
                          maxlength="100">
                        <mat-error
                          *ngIf="!personaFormGroup.controls['MovilContacto'].valid && personaFormGroup.controls['MovilContacto'].touched">
                          {{ getErrorMovilContacto() }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                  </div>

                </form>

                <ng-container *ngIf="!canPersonEdit || !esNuevo">

                  <div fxLayout="row stretch" class="zb-readonly" *ngIf="!(item?.PersonaId > 0)"
                    style="margin-top: 15px;">
                    <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!esNuevo">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label>No hay persona asociada al incidente.</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                  </div>

                  <div fxLayout="row stretch" class="zb-readonly" *ngIf="item?.PersonaId > 0" style="margin-top: 15px;">

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label><b>Nombre</b>: {{persona.Nombre}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label><b>Apellido</b>: {{persona.Apellido}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label><b>Tipo Doc.</b>: {{persona.TipoDocumentoNombre}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label><b>Nro. Doc.</b>: {{persona.NroDocumento}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label><b>CUIT</b>: {{persona.Cuit}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label><b>Fecha Nacimiento</b>: {{persona.FechaNacimiento |
                            date:'dd/MM/yyyy'}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label><b>Mail de Contacto</b>: {{persona.MailContacto}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label><b>Móvil de Contacto</b>: {{persona.MovilContacto}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                    <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label><b>Domicilio Real</b>: {{persona.DomicilioReal}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                  </div>

                </ng-container>

              </mat-tab>

              <mat-tab label="{{'Proveedor' | translate}}" *ngIf="canAsociarProveedor">

                <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;">

                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                    <ng-container *ngIf="esNuevo">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <input type="text" placeholder="Proveedor" aria-label="Proveedor" matInput
                          [matAutocomplete]="proveedor" formControlName="Proveedor">
                        <i [ngStyle]="{'display': isProveedorAutoSearching ? 'inline-block' : 'none'}"
                          class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                      </mat-form-field>
                      <mat-autocomplete #proveedor="matAutocomplete" [displayWith]="displayProveedor"
                        (optionSelected)="onProveedorChange()">
                        <mat-option *ngFor="let s of filteredProveedorList" [value]="s">
                          {{s.RazonSocial }}
                        </mat-option>
                      </mat-autocomplete>
                    </ng-container>
                    <ng-container *ngIf="!esNuevo">
                      <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!esNuevo">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label><b>{{ 'Proveedor' | translate}}:</b> {{item.ProveedorNombre}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </ng-container>

                  </div>

                </div>

              </mat-tab>

              <mat-tab label="{{'Pedido' | translate}}" *ngIf="canAsociarPedido">

                <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;">

                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                    <ng-container *ngIf="esNuevo">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <input type="text" placeholder="Nro. Pedido" aria-label="Pedido" matInput
                          [matAutocomplete]="pedido" formControlName="Pedido">
                        <i [ngStyle]="{'display': isPedidoAutoSearching ? 'inline-block' : 'none'}"
                          class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                      </mat-form-field>
                      <mat-autocomplete #pedido="matAutocomplete" [displayWith]="displayPedido">
                        <mat-option *ngFor="let s of filteredPedidoList" [value]="s">
                          #{{s.Id}} - {{s.ComunidadOrigenNombre}} > {{s.ComunidadDestinoNombre}}
                        </mat-option>
                      </mat-autocomplete>
                    </ng-container>
                    <ng-container *ngIf="!esNuevo">
                      <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!esNuevo">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label><b>{{ 'Pedido' | translate}}:</b> {{item.PedidoId > 0 ? '#'+item.PedidoId :
                            ''}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </ng-container>

                  </div>

                </div>

              </mat-tab>

              <mat-tab label="{{'Comunidad' | translate}}" *ngIf="canAsociarComunidad">

                <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;">

                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                    <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!esNuevo">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label><b>{{ 'Comunidad' | translate}}:</b> {{item.ComunidadNombre}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                    <mat-form-field appearance="outline" style="width: 100%" *ngIf="esNuevo">
                      <mat-label *ngIf="!isComunidadSearching">{{ 'Comunidad' | translate}}</mat-label>
                      <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                      <mat-select formControlName="ComunidadId">
                        <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>

                  </div>

                </div>

              </mat-tab>

              <mat-tab label="{{'Contrato' | translate}}" *ngIf="canAsociarContrato">

                <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;">

                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                    <ng-container *ngIf="esNuevo">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <input type="text" placeholder="Cód. Contrato" aria-label="Contrato" matInput
                          [matAutocomplete]="contrato" formControlName="Contrato">
                        <i [ngStyle]="{'display': isContratoAutoSearching ? 'inline-block' : 'none'}"
                          class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                      </mat-form-field>
                      <mat-autocomplete #contrato="matAutocomplete" [displayWith]="displayContrato">
                        <mat-option *ngFor="let s of filteredContratoList" [value]="s">
                          {{s.Codigo}}
                        </mat-option>
                      </mat-autocomplete>
                    </ng-container>
                    <ng-container *ngIf="!esNuevo">
                      <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!esNuevo">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label><b>{{ 'Contrato' | translate}}:</b> {{item.ContratoId > 0 ? item.Contrato : ''}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </ng-container>

                  </div>

                </div>

              </mat-tab>

              <mat-tab label="{{'UnidadFuncional' | translate}}" *ngIf="canAsociarUnidadFuncional">

                <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;">

                  <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="!esNuevo">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label><b>{{ 'UnidadFuncional' | translate}}:</b> {{item.UnidadFuncional}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>

                  <ng-container *ngIf="esNuevo">
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                        <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                        <mat-select formControlName="ComunidadId" (selectionChange)="onFiltroUfComunidadSelect()">
                          <mat-option>Todos</mat-option>
                          <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label *ngIf="!isUnidadesFuncionalesSearching">{{'UnidadFuncional' | translate}}</mat-label>
                        <mat-label *ngIf="isUnidadesFuncionalesSearching">Cargando...</mat-label>
                        <mat-select formControlName="UnidadFuncionalId">
                          <mat-option>Ninguna</mat-option>
                          <mat-option *ngFor="let s of ufList" [value]="s.Id">{{s.Codigo}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </ng-container>

                </div>

              </mat-tab>

            </mat-tab-group>

          </mat-expansion-panel>

        </ng-container>

      </form>

    </ng-container>

  </mat-card-content>

</mat-card>

<ng-container *ngIf="!isSearching && item != null && !esNuevo">

  <hr style="width: 100%;">

  <mat-card class="example-card" style="margin-bottom: 0px;">
    <mat-card-header class="card-header">
      <mat-card-title>Hilo de Mensajes</mat-card-title>
      <mat-card-subtitle></mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>

      <div id="hiloMensajesDiv" fxLayout="row stretch" class="zb-readonly" style="max-height: 50vh; overflow-y: auto;">

        <mat-label *ngIf="isHiloSearching"><i class="fa fa-spinner fa-spin"></i> Cargando mensajes...</mat-label>

        <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngFor="let msg of hiloList">

          <mat-expansion-panel [expanded]="true" style="padding: 0px; margin: 10px 0px;" hideToggle="true">

            <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
              <mat-label [ngStyle]="{'color': (msg.UsuarioCreadorId == loggedUserId ? 'indianred' : 'black')}">
                <b>{{(msg.FechaCreacion | date:'dd/MM/yyyy HH:mm:ss') + ' - Mensaje enviado por ' +
                  msg.UsuarioCreadorLogin}} :</b>
              </mat-label>
            </div>
            <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 5px 0px;">
              <div fxFlex=100 fxFlex.xs=100 class="flex-item message-no-style"
                style="border: 2px gray solid; border-radius: 5px; margin:0px 0px; padding-top: 16px;"
                [innerHTML]="msg.MensajeHtml">
              </div>
            </div>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="msg.Adjuntos != null && msg.Adjuntos.length > 0">
              <hr style="margin:5px 0px; width: 100%;">

              <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="!isAttachmentSearching">
                <a *ngFor="let file of msg.Adjuntos" href="{{file.UrlDocumento}}" target="_blank"
                  title="{{file.NombreDocumento}}" style="float: right; margin-left: 5px;">
                  <i class="fa fa-file"></i>
                </a>
              </div>
            </div>
          </mat-expansion-panel>

        </div>

      </div>

    </mat-card-content>

  </mat-card>

</ng-container>

<hr style="width: 100%;" *ngIf="!isSearching && item != null">

<mat-card *ngIf="!isSearching && item != null" class="example-card">

  <mat-card-header class="card-header" *ngIf="item.Editable">
    <mat-card-title>{{esNuevo ? 'Detalle de Incidencia' : 'Actualizar Incidencia'}}</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content *ngIf="item.Editable">

    <form [formGroup]="formResponse">

      <mat-expansion-panel [expanded]="true" hideToggle="true">

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
          <mat-label style="font-size: 14px; font-weight: bold;">Escriba un mensaje a continuación para actualizar la
            incidencia:</mat-label>
        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <ejs-richtexteditor #mensajeRte formControlName="Mensaje" [toolbarSettings]='tools'
              [insertImageSettings]='insertImageSettings' (imageUploading)="imageUploading($event)"
              (imageUploadSuccess)="imageUploadSuccess($event)">
            </ejs-richtexteditor>
          </div>
        </div>

        <div fxLayout="row stretch" fxLayout.xs="column">
          <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
            <mat-checkbox [(ngModel)]="debeEnviarMail" [ngModelOptions]="{standalone: true}" (change)="onCheckEnvioEmail($event)" color="primary">Envío por email </mat-checkbox>
          </div>
        </div>
        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="debeEnviarMail">
          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Para:</mat-label>
              <input matInput type="text" [(ngModel)]="destinatarios" [ngModelOptions]="{standalone: true}">
              <mat-hint>Ingrese los emails separados por '<b>;</b>'</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>

      <br />

      <mat-expansion-panel [expanded]="true" hideToggle="true">

        <div fxLayout="row stretch" fxLayout.xs="column">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;">
            <mat-nav-list>
              <mat-list-item *ngFor="let file of adjuntosList"
                style="background-color: lightgray; margin: 5px 0px;border-radius: 10px;">
                <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
                <button mat-icon-button (click)="onFileAttachedDelete(file)" title="Eliminar adjunto">
                  <i class="fa fa-trash fa-1x"></i>
                </button>
              </mat-list-item>
            </mat-nav-list>
          </div>

          <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;">
            <button class="text-style" mat-icon-button matSuffix (click)="fileInput.click()"
              [disabled]="isFileAttaching"><mat-icon style="margin-right: 5px;">attach_file</mat-icon> Agregar
              adjunto</button>
            <input class="text-style" hidden (change)="onNewFileAttach($event)" #fileInput type="file" multiple>
            <mat-label class="text-style" *ngIf="isFileAttaching"><br /><i class="fa fa-spinner fa-spin"></i> Subiendo
              archivo...</mat-label>
          </div>

        </div>

      </mat-expansion-panel>

    </form>

  </mat-card-content>

  <mat-card-actions>
    <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">
      <button mat-raised-button color="primary" (click)="onGuardar()" *ngIf="item.Editable" [disabled]="isProcessing()"
        class="zb-button">{{isSaving ? 'Enviando...' : 'Enviar'}}</button>
      <button mat-raised-button (click)="onCancel()" class="zb-button">Volver </button>
    </div>
  </mat-card-actions>

</mat-card>
